document.addEventListener('DOMContentLoaded', function () {
  // 创建 IntersectionObserver 实例
  window.YGImageLoader = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        const newImg = new Image();
        newImg.onload = () => {
          img.src = newImg.src;
          img.removeAttribute('data-src');  // 如果只需要加载一次
          img.removeAttribute('srcset');
          observer.unobserve(img);          // 停止观察该元素
        }
        newImg.src = img.getAttribute('data-src');
      }
    });
  }, {
    rootMargin: "50px", // 预加载距离视口 50px 的图片
  });

  class YGImage extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      // 这里放置初始化逻辑
      this.loaderImg()
    }

    get images() {
      return this.querySelectorAll('img[data-src]')
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        window.YGImageLoader.observe(img)
      })
    }
  }
  if (!window.customElements.get('yg-image')) {
    window.customElements.define('yg-image', YGImage)
  }

  class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (e) => {
        this.closePopup(e, () => { });
      });
    }

    openPopup($popupTemplate, fn) {
      // popupTemplate：需要替换的元素
      this.querySelector('.yg-popup-box-content-inner').innerHTML = $popupTemplate.innerHTML;
      document.querySelector('body').style.overflow = 'hidden';
      this.style.display = 'flex';
      fn();
    }
    closePopup(e, fn) {
      if (e.target.className == 'yg-popup-box-close' || e.target.className == 'yg-popup-box') {
        this.style.display = 'none';
        this.querySelector('.yg-popup-box-content-inner').innerHTML = '';
        document.querySelector('body').style.overflow = 'auto';
        fn();
      }
    }
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }

  class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.$popupBox = document.querySelector('yg-popup-box.yg-popup-box');
    }
    init() {
      // 这里放置初始化逻辑
      this.addEventListener('click', this.itemClick.bind(this));
    }
    itemClick() {
      // 这里放置自定义逻辑
      let $popupTemplate = this.querySelector('template') || this.querySelector('.yg-popup-template');

      $popupTemplate && this.$popupBox.openPopup($popupTemplate, () => { });

    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }

  class YGSwiper extends HTMLElement {
    constructor() {
      super()
    }
    connectedCallback() {
      this.getAllAttributes()
      this.initSwiper()
    }

    get getCurrentSlidesPerView() {
      if (!this['breakpoints']) return 1;

      const screenWidth = window.innerWidth;

      // 将breakpoints按数值从小到大排序
      const sortedKeys = Object.keys(this['breakpoints']).map(Number).sort((a, b) => a - b);

      let current = sortedKeys[0]; // 默认取最小的

      // 遍历找到小于等于当前屏幕宽度的最大key
      for (let i = 0; i < sortedKeys.length; i++) {
        if (screenWidth >= sortedKeys[i]) {
          current = sortedKeys[i];
        } else {
          break;
        }
      }

      return this['breakpoints'][current].slidesPerView;
    }

    getAllAttributes() {
      let booleanAttrs = ['loop', 'pagination', 'navigation', 'centered-slides'];
      let jsonAttrs = ['breakpoints']
      for (const attr of this.attributes) {
        if (attr.name.startsWith('data-')) {
          const cleanName = attr.name.slice(5); // 去除 'data-' 前缀

          let value = attr.value;
          if (booleanAttrs.includes(cleanName)) {
            value = value === 'true';
          } else if (jsonAttrs.includes(cleanName)) {
            value = this.parseSwiperBreakpoints(value);
          }

          this[cleanName] = value;
        }
      }
    }

    parseSwiperBreakpoints(str) {
      const result = {};
      const pairs = str.split(',');

      for (const pair of pairs) {
        const [breakpoint, values] = pair.split(':');
        if (!breakpoint || !values) continue;

        const [slides, space] = values.split('-').map(Number);

        result[breakpoint.trim()] = {
          slidesPerView: slides,
          spaceBetween: space
        };
      }

      return result;
    }

    initSwiper() {
      const swiper = new Swiper(this, {
        // 这里放置 swiper 的配置
        effect: this['effect'],
        loop: this['loop'],
        centeredSlides: this['centered-slides'],
        autoplay: this['autoplay'] ? {
          delay: this['autoplay'],
          stopOnLastSlide: false,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        } : false,
        pagination: this['pagination'] ? {
          el: '.swiper-pagination',
          clickable: true,
        } : false,
        navigation: this['navigation'] ? {
          nextEl: this['navigation-class']? `.${this['navigation-class']}-next`:'.swiper-button-next',
          prevEl: this['navigation-class']? `.${this['navigation-class']}-prev`:'.swiper-button-prev',
        } : false,
        breakpoints: this['breakpoints'] ? this['breakpoints'] : false,
        on: {
          init: e => {
            if (e.passedParams.loop) {
              let num = this.getCurrentSlidesPerView;
              let sliderLength = e.slides.length;

              if (this['centered-slides']) {
                num += 2;
              }

              if (sliderLength <= num) {
                for (let index = 1; index < Math.ceil(num / sliderLength); index++) {
                  e.slides.forEach((slide) => {
                    const clonedElement = slide.cloneNode(true);
                    e.slidesEl.appendChild(clonedElement);
                  })
                }

                setTimeout(() => {
                  let $bullets = this.querySelectorAll('.swiper-pagination-bullet');
                  $bullets.forEach((bullet, index) => {
                    if (index >= sliderLength) {
                      bullet.style.display = 'none';
                    }
                  })
                }, 250)
              }
            }
          }
        }
      })
    }
  }
  if (!window.customElements.get('yg-swiper')) {
    window.customElements.define('yg-swiper', YGSwiper)
  }

  class YGProductTabs extends HTMLElement {
    constructor() {
      super()
      this.itemClick = this.itemClick.bind(this);

      this.tabs = this.querySelectorAll('.yg-image-item')
      this.contents = this.querySelectorAll('.yg-products-item')
    }
    connectedCallback() {
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.itemClick(index));
      })
    }
    disconnectedCallback() {
      this.tabs.forEach((tab, index) => {
        tab.removeEventListener('click', () => this.itemClick(index));
      })
    }
    itemClick(i) {
      // 这里放置自定义逻辑
      if (!this.tabs[i].classList.contains('active')) {
        this.tabs.forEach(tab => {
          tab.classList.remove('active')
        })
        this.contents.forEach(content => {
          content.classList.remove('active')
        })
      }

      this.tabs[i].classList.toggle('active')
      this.contents[i]?.classList.toggle('active')
    }
  }
  if (!window.customElements.get('yg-product-tabs')) {
    window.customElements.define('yg-product-tabs', YGProductTabs)
  }
  class YGCollapse extends HTMLElement {
    constructor() {
      super()
      this.itemClick = this.handClick.bind(this);
      this.$contentList = this.contentList
      this.$btnList = this.btnList
      this.$iconList = this.btnIcon
    }
    get contentList() {
      if (!this.$contentList) {
        this.$contentList = this.querySelectorAll('.yg-collapse-content')
      }
      return this.$contentList
    }
    get btnList() {
      if (!this.$btnList) {
        this.$btnList = this.querySelectorAll('.yg-collapse-btn')
      }
      return this.$btnList
    }
    get btnIcon() {
      if (!this.$iconList) {
        this.$iconList = this.querySelectorAll('.yg-collapse-icon')
      }
      return this.$iconList
    }

    handClick(e, i) {
      if (!this.$contentList[i].classList.contains("active")) {
        this.$contentList[i].classList.add('active')
        this.$iconList[i].style.transform = 'rotate(0deg)'
      } else {
        this.$contentList[i].classList.remove('active')
        this.$iconList[i].style.transform = 'rotate(180deg)'

      }

    }

    connectedCallback() {

      this.$btnList.forEach((item, index) => {
        item.addEventListener('click', (e) => {
          this.itemClick(e, index)
        })
      })
    }
    disconnectedCallback() {

    }
  }
  if (!window.customElements.get('yg-collapse')) {
    window.customElements.define('yg-collapse', YGCollapse)
  }
  class YGJump extends HTMLElement {
    constructor() {
      super()
      this.$linkTextList = this.linktext
      this.$scrollBox = this.scrollBox
      this.$videoList = this.videolist
    }
    get linktext() {
      if (!this.$linkTextList) {
        this.$linkTextList = this.querySelectorAll('.yg-url-item > div')
      }
      return this.$linkTextList
    }
    get scrollBox() {
      if (!this.$scrollBox) {
        this.$scrollBox = this.querySelector('.yg-scroll-box')
      }
      return this.$scrollBox
    }
    get videolist() {
      if (!this.$videoList) {
        this.$videoList = this.querySelectorAll('.video-item')
      }
      return this.$videoList
    }
    isScrollable(el) {
      if (!el) return false;

      const style = window.getComputedStyle(el);
      const overflowY = style.overflowY;
      const overflowX = style.overflowX;

      const canScrollVertically = (overflowY === 'scroll' || overflowY === 'auto') && el.scrollHeight > el.clientHeight;
      const canScrollHorizontally = (overflowX === 'scroll' || overflowX === 'auto') && el.scrollWidth > el.clientWidth;

      return canScrollVertically || canScrollHorizontally;
    }
    handClick(e, i) {

        const scrollTop = this.$videoList[i].offsetTop- 80

        window.scrollTo({
          top: scrollTop,
          behavior: 'smooth'
        });
      
    }

    connectedCallback() {

      this.$linkTextList.forEach(($link, index) => {
        $link.addEventListener('click', e => this.handClick(e, index))
      })
    }
    disconnectedCallback() {
      this.$linkTextList.forEach(($link, index) => {
        $link.removeEventListener('click', e => this.handClick(e, index))
      })
    }

  }
  if (!window.customElements.get('yg-jump')) {
    window.customElements.define('yg-jump', YGJump)
  }
})